import { IAreaTypesData, IAreaData, ParamMetaData, AuthType } from '@aex/shared/common-lib';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AreaApi } from '../api';

@Injectable({
	providedIn: 'root',
})
export class AreaService {
	constructor(private readonly http: HttpClient) {}

	public getAllAreaTypes(): Observable<HttpResponse<IAreaTypesData>> {
		return this.http.get<IAreaTypesData>(AreaApi.areaTypes(), {
			params: new ParamMetaData({ authToken: AuthType.USER }),
			observe: 'response',
		});
	}

	public getAllAreas(id: number, count: string = '10'): Observable<HttpResponse<IAreaData>> {
		let url = AreaApi.areasByType(id)
		url += `&count=${count}`;

		return this.http.get<IAreaData>(url, { observe: 'response' });
	}

	public getAllSubAreas(id: string, count: string = '10'): Observable<HttpResponse<IAreaData>> {
		let url = AreaApi.areasByParent(id);
		url += `&count=${count}`;

		return this.http.get<IAreaData>(url, { observe: 'response' });
	}
}
